import { useMemo } from 'react';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useAppSelector } from 'store/hooks';
import { useFeatureFlagValue } from 'store/session/hooks';
import {
  getAvailableGroupMembers,
  getUserGroupCollectionId,
  getIsSuperuser,
  getActiveGroup,
} from 'store/session/selectors';

import { useUserGroupCollectionContext } from '../UserGroupCollectionProvider';

export const useVisibleUserGroups = () => {
  const isSuperuser = useAppSelector(getIsSuperuser);
  const availableGroupMembers = useAppSelector(getAvailableGroupMembers);
  const userGroupCollectionId = useAppSelector(getUserGroupCollectionId);
  const activeGroup = useAppSelector(getActiveGroup);
  const { userGroupsById, getUserGroupById } = useUserGroupCollectionContext();
  const isMultisiteEnabled = useFeatureFlagValue(
    featureFlagKeys.isMultisiteFunctionalityAvailable,
  );

  return useMemo(() => {
    if (isMultisiteEnabled && !!userGroupCollectionId) {
      if (isSuperuser) {
        return Object.values(userGroupsById);
      } else {
        return availableGroupMembers
          .map((groupMember) => getUserGroupById(groupMember.group.id))
          .filter((userGroup) => !!userGroup);
      }
    } else {
      const visibleGroup = activeGroup
        ? getUserGroupById(activeGroup.id) // match the return type of the other cases
        : null;
      return visibleGroup ? [visibleGroup] : [];
    }
  }, [
    activeGroup,
    availableGroupMembers,
    isMultisiteEnabled,
    isSuperuser,
    userGroupCollectionId,
    userGroupsById,
    getUserGroupById,
  ]);
};
